import { UserStatus } from '../modules/UsersModule/types'
import User from '../modules/UsersModule/types/User'

export const getMenuDisabled = (pathname: string, profile?: User) =>
  profile?.status === UserStatus.Unconfirmed || pathname.includes('payment-required')
